import { initializeApp, getApps, FirebaseApp } from 'firebase/app';
import { getAuth, GoogleAuthProvider, browserLocalPersistence, setPersistence } from 'firebase/auth';
import { getStorage } from 'firebase/storage';

const firebaseConfig = {
  apiKey:            process.env.REACT_APP_FIREBASE_API_KEY            || 'AIzaSyBtmnIet_dsqzz5JUKopGuwSrrg7c9pANU',
  authDomain:        process.env.REACT_APP_FIREBASE_AUTH_DOMAIN        || 'bunyadkar-backend.firebaseapp.com',
  projectId:         process.env.REACT_APP_FIREBASE_PROJECT_ID         || 'bunyadkar-backend',
  storageBucket:     process.env.REACT_APP_FIREBASE_STORAGE_BUCKET     || 'bunyadkar-backend.firebasestorage.app',
  messagingSenderId: process.env.REACT_APP_FIREBASE_MESSAGING_SENDER_ID|| '273399179602',
  appId:             process.env.REACT_APP_FIREBASE_APP_ID             || '1:273399179602:web:1547d0327fa0189d8ef28b',
  measurementId:     process.env.REACT_APP_FIREBASE_MEASUREMENT_ID     || 'G-7HH2V211K1',
};

const app: FirebaseApp = getApps().length ? getApps()[0] : initializeApp(firebaseConfig);

export const auth = getAuth(app);
export const googleProvider = new GoogleAuthProvider();
googleProvider.setCustomParameters({ prompt: 'select_account' });

export const storage = getStorage(app);

// Persist sessions across reloads. Firebase rejects this gracefully in environments
// without storage (SSR, file://) — swallow that error.
setPersistence(auth, browserLocalPersistence).catch(() => { /* no-op */ });

export default app;
